import { IInfrontStock } from "@portal/infront/hooks/useInfrontStocks/types";

export type Field = keyof IInfrontStock;
type Listener = (ticker?: string, field?: Field, value?: string | number) => void | (() => void);

let listeners = [] as Listener[];

const emptyStock = {
  ticker: "",
  last: 0,
  yesterdayClose: 0,
  change: 0,
  changePercent: 0,
  name: "",
  feed: 0,
  turnover: 0,
  isin: "",
  flag: "",
  instrumentSubType: "",
  displaySymbolStatus: "",
} as IInfrontStock;

let stocks = [] as IInfrontStock[];

export const stocksStore = {
  updateStock(ticker: string, field: Field, newValue: string | number) {
    if (!ticker) return;
    const stockIndex = stocks.findIndex(o => o.ticker === ticker);
    if (stockIndex >= 0) {
      stocks = [
        ...stocks.slice(0, stockIndex),
        {
          ...stocks[stockIndex],
          [field]: newValue,
        },
        ...stocks.slice(stockIndex + 1),
      ];
    } else {
      stocks = [
        ...stocks,
        {
          ...emptyStock,
          ticker: ticker,
          [field]: newValue,
        },
      ];
    }
    emitChange(ticker, field, newValue);
  },
  subscribe(listener: Listener) {
    listeners = [...listeners, listener];
    return () => {
      listeners = listeners.filter(l => l !== listener);
    };
  },
  getSnapshot() {
    return stocks;
  },
};

const emitChange = (ticker?: string, field?: Field, value?: string | number) => {
  for (const listener of listeners) {
    listener(ticker, field, value);
  }
};
